import {
  readStoredItem,
  removeStoredItem,
  writeStoredItem,
  SESSION_SCOPE,
} from 'src/utils/storageManager';

// Lightweight health probe for a preview backend, plus a one-shot "reverted at boot" notice.

const HEALTH_PATH = '/api/health';
const REVERT_KEY = 'baobab_preview_revert_notice';

export const probeBackendHealth = async (
  apiUrl: string | null | undefined,
  timeoutMs = 60000,
): Promise<boolean> => {
  if (!apiUrl) return false;
  const url = `${apiUrl.replace(/\/+$/, '')}${HEALTH_PATH}`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, { signal: controller.signal });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
};

export const setRevertNotice = (slug: string): void => {
  writeStoredItem(REVERT_KEY, slug, SESSION_SCOPE);
};

export const getRevertNotice = (): string | null => readStoredItem(REVERT_KEY, SESSION_SCOPE);

export const clearRevertNotice = (): void => {
  removeStoredItem(REVERT_KEY, SESSION_SCOPE);
};
